import { defineMessages } from 'react-intl';

/** The copy of "Add yours" (design music-video a1–a7, spec 2026-10-09 §3). */
export const addedAssetsMessages = defineMessages({
  // Dialog (a2–a4)
  titleMusicVideo: { id: 'app.sml.addedAssets.title.musicVideo', defaultMessage: 'Add the music video of {title}' },
  titleLyricVideo: { id: 'app.sml.addedAssets.title.lyricVideo', defaultMessage: 'Add the lyric video of {title}' },
  titleVisualizer: { id: 'app.sml.addedAssets.title.visualizer', defaultMessage: 'Add the visualizer of {title}' },
  titleCanvasLoop: { id: 'app.sml.addedAssets.title.canvasLoop', defaultMessage: 'Add the Canvas loop of {title}' },
  sub: {
    id: 'app.sml.addedAssets.sub',
    defaultMessage:
      'Link the video on YouTube, or upload the file. It shows in the Catalog, the Kit, on the SmartLink and in the release plan.',
  },
  subCanvas: {
    id: 'app.sml.addedAssets.subCanvas',
    defaultMessage: 'Upload the loop you set in Spotify for Artists. It shows in the Kit.',
  },
  tabYouTube: { id: 'app.sml.addedAssets.tab.youtube', defaultMessage: 'From YouTube' },
  tabUpload: { id: 'app.sml.addedAssets.tab.upload', defaultMessage: 'Upload the file' },
  tabMake: { id: 'app.sml.addedAssets.tab.make', defaultMessage: 'Make one instead' },
  cancel: { id: 'app.sml.addedAssets.cancel', defaultMessage: 'Cancel' },
  close: { id: 'app.sml.addedAssets.close', defaultMessage: 'Close' },
  done: { id: 'app.sml.addedAssets.done', defaultMessage: 'Done' },
  // YouTube (a2, a3)
  videosOn: { id: 'app.sml.addedAssets.youtube.videosOn', defaultMessage: 'Videos on {channel}, newest first' },
  pasteLink: { id: 'app.sml.addedAssets.youtube.pasteLink', defaultMessage: 'Paste a link' },
  pickFromChannel: { id: 'app.sml.addedAssets.youtube.pickFromChannel', defaultMessage: 'Pick from your channel' },
  bestMatch: { id: 'app.sml.addedAssets.youtube.bestMatch', defaultMessage: 'Best match' },
  bestMatchHint: {
    id: 'app.sml.addedAssets.youtube.bestMatchHint',
    defaultMessage: 'Same title and length as the song: {length}',
  },
  views: { id: 'app.sml.addedAssets.youtube.views', defaultMessage: '{count, plural, one {# view} other {# views}}' },
  privacyPublic: { id: 'app.sml.addedAssets.youtube.privacy.public', defaultMessage: 'public' },
  privacyUnlisted: { id: 'app.sml.addedAssets.youtube.privacy.unlisted', defaultMessage: 'unlisted' },
  privacyPrivate: { id: 'app.sml.addedAssets.youtube.privacy.private', defaultMessage: 'private' },
  linkedElsewhere: { id: 'app.sml.addedAssets.youtube.linkedElsewhere', defaultMessage: 'Linked to another song' },
  noVideos: {
    id: 'app.sml.addedAssets.youtube.noVideos',
    defaultMessage: 'We found no videos on your channel yet. Paste a link.',
  },
  linkLabel: { id: 'app.sml.addedAssets.youtube.linkLabel', defaultMessage: 'YouTube link' },
  linkPlaceholder: { id: 'app.sml.addedAssets.youtube.linkPlaceholder', defaultMessage: 'https://youtu.be/…' },
  linkPreview: { id: 'app.sml.addedAssets.youtube.linkPreview', defaultMessage: 'YouTube video {id}' },
  otherChannel: {
    id: 'app.sml.addedAssets.youtube.otherChannel',
    defaultMessage:
      'This video is not on a channel you connected. It is fine to link it. We show it as "On YouTube", but we can not show its views.',
  },
  connectChannel: { id: 'app.sml.addedAssets.youtube.connectChannel', defaultMessage: 'Connect a channel' },
  useVideo: { id: 'app.sml.addedAssets.youtube.useVideo', defaultMessage: 'Use this video' },
  linking: { id: 'app.sml.addedAssets.youtube.linking', defaultMessage: 'Linking…' },
  // Errors (a3 note, M24_ADDED_*)
  errorNotYouTube: { id: 'app.sml.addedAssets.error.notYouTube', defaultMessage: 'This is not a YouTube video link.' },
  errorPrivate: {
    id: 'app.sml.addedAssets.error.private',
    defaultMessage: 'This video is private. Make it public or unlisted, or upload the file.',
  },
  errorNotFound: { id: 'app.sml.addedAssets.error.notFound', defaultMessage: 'We could not find this video.' },
  errorNotAllowed: {
    id: 'app.sml.addedAssets.error.notAllowed',
    defaultMessage: 'You can not add this kind of video here.',
  },
  errorTooLarge: { id: 'app.sml.addedAssets.error.tooLarge', defaultMessage: 'The file is too large.' },
  errorTooLargeCanvas: {
    id: 'app.sml.addedAssets.error.tooLargeCanvas',
    defaultMessage: 'A Canvas loop can be 8 MB at most. Export a smaller file.',
  },
  errorType: { id: 'app.sml.addedAssets.error.type', defaultMessage: 'Upload an MP4 or a MOV file.' },
  errorTypeCanvas: { id: 'app.sml.addedAssets.error.typeCanvas', defaultMessage: 'Upload an MP4 file.' },
  errorUnreadable: {
    id: 'app.sml.addedAssets.error.unreadable',
    defaultMessage: 'We could not read this video. Export it again as MP4 and try again.',
  },
  errorTooShort: { id: 'app.sml.addedAssets.error.tooShort', defaultMessage: 'The video is too short.' },
  errorTooLong: { id: 'app.sml.addedAssets.error.tooLong', defaultMessage: 'The video is too long.' },
  errorCanvasLength: {
    id: 'app.sml.addedAssets.error.canvasLength',
    defaultMessage: 'A Canvas loop is 3 to 8 seconds long.',
  },
  errorShape: { id: 'app.sml.addedAssets.error.shape', defaultMessage: 'A Canvas loop must be 9:16 (portrait).' },
  errorTooSmall: {
    id: 'app.sml.addedAssets.error.tooSmall',
    defaultMessage: 'A Canvas loop must be at least 720 px tall.',
  },
  errorUploadStopped: {
    id: 'app.sml.addedAssets.error.uploadStopped',
    defaultMessage: 'The upload stopped. Check your connection and try again.',
  },
  errorFailed: { id: 'app.sml.addedAssets.error.failed', defaultMessage: 'We could not add the video. Try again.' },
  // Upload (a4)
  dropTitle: { id: 'app.sml.addedAssets.upload.dropTitle', defaultMessage: 'Drop the file here' },
  chooseFile: { id: 'app.sml.addedAssets.upload.chooseFile', defaultMessage: 'Choose a file' },
  sizeLine: { id: 'app.sml.addedAssets.upload.sizeLine', defaultMessage: '{sent} of {total}' },
  measures: { id: 'app.sml.addedAssets.upload.measures', defaultMessage: '{width} × {height} · {length}' },
  checking: { id: 'app.sml.addedAssets.upload.checking', defaultMessage: 'We check the video…' },
  uploading: { id: 'app.sml.addedAssets.upload.uploading', defaultMessage: 'Uploading…' },
  cancelUpload: { id: 'app.sml.addedAssets.upload.cancel', defaultMessage: 'Stop the upload' },
  added: { id: 'app.sml.addedAssets.upload.added', defaultMessage: 'Added. It is in the Kit now.' },
  tryAgain: { id: 'app.sml.addedAssets.upload.tryAgain', defaultMessage: 'Try again' },
  lengthMatches: {
    id: 'app.sml.addedAssets.upload.lengthMatches',
    defaultMessage: 'The length matches the song ({length}).',
  },
  lengthDiffers: {
    id: 'app.sml.addedAssets.upload.lengthDiffers',
    defaultMessage: 'The video is {video}. The song is {song}. Is it the right file?',
  },
  soundCheckSoon: {
    id: 'app.sml.addedAssets.upload.soundCheckSoon',
    defaultMessage: 'We check that the sound is {title} after the upload.',
  },
  footLong: {
    id: 'app.sml.addedAssets.upload.footLong',
    defaultMessage: 'MP4 or MOV, any size. You can close this window.',
  },
  footCanvas: { id: 'app.sml.addedAssets.upload.footCanvas', defaultMessage: 'MP4, 3 to 8 seconds, 9:16' },
  // Make one instead
  makeBody: {
    id: 'app.sml.addedAssets.make.body',
    defaultMessage:
      'Make one in the music video editor: footage from our clip bank, AI clips and your own clips, cut on the beat. The preview is free.',
  },
  makeOpen: { id: 'app.sml.addedAssets.make.open', defaultMessage: 'Open the editor' },
  // Kit slot (a1, a5, a6, a7)
  stateAdded: { id: 'app.sml.addedAssets.kit.stateAdded', defaultMessage: 'Added' },
  addYourVideo: { id: 'app.sml.addedAssets.kit.addYourVideo', defaultMessage: 'Add your video' },
  makeOne: { id: 'app.sml.addedAssets.kit.makeOne', defaultMessage: 'Make one' },
  addYours: { id: 'app.sml.addedAssets.kit.addYours', defaultMessage: 'Add yours' },
  musicVideoLine: {
    id: 'app.sml.addedAssets.kit.musicVideoLine',
    defaultMessage:
      'Already have one? Add it. Or make one from our clip bank, AI clips and your own footage, cut on the beat.',
  },
  linkedBadge: { id: 'app.sml.addedAssets.kit.linkedBadge', defaultMessage: 'Linked' },
  onYouTube: { id: 'app.sml.addedAssets.kit.onYouTube', defaultMessage: 'On YouTube' },
  onYouTubeViews: {
    id: 'app.sml.addedAssets.kit.onYouTubeViews',
    defaultMessage: '{count, plural, one {On YouTube · # view} other {On YouTube · # views}}',
  },
  yourFile: { id: 'app.sml.addedAssets.kit.yourFile', defaultMessage: 'Your file' },
  yourFileSize: { id: 'app.sml.addedAssets.kit.yourFileSize', defaultMessage: 'Your file · {size}' },
  noFileLine: {
    id: 'app.sml.addedAssets.kit.noFileLine',
    defaultMessage: 'No file in MUSIC24, so posts can not use parts of it.',
  },
  uploadFileToo: { id: 'app.sml.addedAssets.kit.uploadFileToo', defaultMessage: 'Upload the file too' },
  studioCanCut: {
    id: 'app.sml.addedAssets.kit.studioCanCut',
    defaultMessage: 'The Studio can cut Shorts, Reels and a Canvas loop from it.',
  },
  openOnYouTube: { id: 'app.sml.addedAssets.kit.openOnYouTube', defaultMessage: 'Open on YouTube' },
  change: { id: 'app.sml.addedAssets.kit.change', defaultMessage: 'Change' },
  remove: { id: 'app.sml.addedAssets.kit.remove', defaultMessage: 'Remove' },
  makePosts: { id: 'app.sml.addedAssets.kit.makePosts', defaultMessage: 'Make posts from it' },
  madeCut: { id: 'app.sml.addedAssets.kit.madeCut', defaultMessage: 'Made from cut {number}' },
  editVideo: { id: 'app.sml.addedAssets.kit.editVideo', defaultMessage: 'Edit the video' },
  openEditor: { id: 'app.sml.addedAssets.kit.openEditor', defaultMessage: 'Open the editor' },
  uploadingLine: { id: 'app.sml.addedAssets.kit.uploadingLine', defaultMessage: 'Uploading your file · {percent}%' },
  soundMismatch: {
    id: 'app.sml.addedAssets.kit.soundMismatch',
    defaultMessage: 'The sound is not {title}. Is it the right file?',
  },
  removeTitle: { id: 'app.sml.addedAssets.remove.title', defaultMessage: 'Remove the {name}?' },
  removeBody: {
    id: 'app.sml.addedAssets.remove.body',
    defaultMessage: 'MUSIC24 forgets the video you added. The video on YouTube or on your computer stays.',
  },
  removeConfirm: { id: 'app.sml.addedAssets.remove.confirm', defaultMessage: 'Remove' },
  removeFailed: { id: 'app.sml.addedAssets.remove.failed', defaultMessage: 'We could not remove it. Try again.' },
  removePublished: {
    id: 'app.sml.addedAssets.remove.published',
    defaultMessage: 'This video is published on YouTube or Facebook. Cancel or remove that publish first.',
  },
});
